import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    root: {
        color: '#0033FF'
    },
}));

const LoadingWheel = (props) => {   
    const classes = useStyles();   
    return (
        <div className="loader"><div className="loaderBg"></div><div className="loaderText"><CircularProgress className={classes.root} /><br />{props.message}</div></div>
    )
}
export default LoadingWheel;

